const DOS = [
  'Take a ritual bath and wear clean clothes before beginning the pooja',
  'Keep a sattvic (vegetarian) diet on the day of the ritual',
  'Complete the full 108 mantra repetitions, ideally with a rudraksha mala',
  'Wear the gemstone at the auspicious day and muhurat advised for its planet',
  'Insist on a lab certificate of natural origin before energizing any stone',
]

const DONTS = [
  'Do not wear a gemstone without a proper astrological consultation',
  'Do not energize or wear uncertified, synthetic or treated stones',
  'Avoid non-vegetarian food and alcohol on the day of the ritual',
  'Do not rush or interrupt the mantra jaap midway',
  'Do not let others handle your energized gemstone casually',
]

export default function DosDontsSection() {
  return (
    <section className="py-20 md:py-24 md:px-12 bg-white">
      <div className="container mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl mx-auto text-center space-y-3 mb-14">
          <div className="flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-secondary/50"></span>
            <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Sacred Discipline</span>
            <span className="h-px w-8 bg-secondary/50"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl uppercase leading-tight text-primary">
            Dos &amp; <span className="text-gradient-gold font-bold">Don&rsquo;ts</span>
          </h2>
          <p className="text-xs md:text-sm leading-relaxed text-gray-500">
            The potency of an energized gemstone depends as much on the wearer&rsquo;s conduct as on the ritual itself.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          <div className="rounded-3xl border border-success/20 bg-success/3 p-8">
            <div className="flex items-center gap-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-success/10 text-success">
                <i className="fa-solid fa-circle-check text-xl"></i>
              </div>
              <h3 className="font-heading text-xl uppercase tracking-wide text-primary font-bold">Recommended</h3>
            </div>
            <ul className="mt-6 space-y-4">
              {DOS.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-gray-600">
                  <i className="fa-solid fa-check mt-1 text-xs text-success"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-3xl border border-danger/20 bg-danger/3 p-8">
            <div className="flex items-center gap-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-danger/10 text-danger">
                <i className="fa-solid fa-circle-xmark text-xl"></i>
              </div>
              <h3 className="font-heading text-xl uppercase tracking-wide text-primary font-bold">Avoid</h3>
            </div>
            <ul className="mt-6 space-y-4">
              {DONTS.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-gray-600">
                  <i className="fa-solid fa-xmark mt-1 text-xs text-danger"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
